import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import FaDate from '../shared/FaDate';
import PresentAbsentSave from './PresentAbsentSave';
import ShowVideo from '../shared/ShowVideo';
import SchoolClassOperation from './SchoolClassOperation';


export default function TeacherAbsentPresent(props) {
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [presentAbsentFormVisible, setPresentAbsentFormVisible] = useState(false);
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [currentTimeId, setCurrentTimeId] = useState("");
  const [currentTimeIndex, setCurrentTimeIndex] = useState(-1);
  const [date, setDate] = useState(0);
  const [weekDayName, setWeekDayName] = useState("");
  const [deleteItemIds, setDeleteItemIds] = useState([]);
  const [schoolClass, setSchoolClass] = useState({});
  const [operation, setOperation] = useState("");
  const [operationFormVisible, setOperationFormVisible] = useState(false);


  const [timings, setTimings] = useState([]);
  const [dayParts, setDayParts] = useState([]);

  useEffect(() => {
    loadData(0);
  }, []);
  const loadData = function (date) {
    setLoading(true);
    var params = { login: util.getTrustedUser(), date: date };
    var url = config.Server + `/school/day/teacher/timing/list`;
    console.log("params is>", params);
    console.log("url is>", url);
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          var dp = [
            { index: 0, title: "زنگ اول" },
            { index: 1, title: "زنگ دوم" },
            { index: 2, title: "زنگ سوم" },
            { index: 3, title: "زنگ چهارم" },
            { index: 4, title: "زنگ پنجم" },
            { index: 5, title: "زنگ ششم" },
          ];

          setDate(response.runClassDate);
          setWeekDayName(response.weekDayName);
          var items = response.schoolClasses;

          console.log("response is >", items)

          setDayParts(dp);
          setTimings(items);

          setLoading(false);

        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setLoading(false);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setLoading(false);
      });
  }
  const btnDeleteByIdClicked = function (timeId) {
    setDeleteItemIds([timeId]);
    setConfirmDeleteVisible(true);
  }
  const onDeleteConfirm_Accept = function () {
    deleteItem();
  }
  const onDeleteConfirm_Reject = function () {
    if (deleting) return;
    setConfirmDeleteVisible(false);
  }
  const deleteItem = function () {
    setDeleting(true);
    var params = { login: util.getTrustedUser(), runClassDate: date, timingIds: deleteItemIds };
    var url = config.Server + `/school/present-absent/delete`;
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          var tmp = [...timings];
          for (var i = 0; i < timings.length; i++) {
            var state = timings[i];
            if (deleteItemIds.includes(state.timeId1)) {
              tmp[i].isDone1 = false;
              tmp[i].present1 = 0;
              tmp[i].legalAbsent1 = 0;
              tmp[i].unLegalAbsent1 = 0;
            }
            else if (deleteItemIds.includes(state.timeId2)) {
              tmp[i].isDone2 = false;
              tmp[i].present2 = 0;
              tmp[i].legalAbsent2 = 0;
              tmp[i].unLegalAbsent2 = 0;
            }
          }
          setTimings(tmp);

          setDeleting(false);
          setConfirmDeleteVisible(false);
        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setDeleting(false);
        }
      })
      .catch(error => {
        setDeleting(false);
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
      });

  }


  const onPresentAbsentChanged = function (timingId, presentCo, legalAbsentCo, unLegalAbsentCo) {
    var tmp = [...timings];
    for (var i = 0; i < timings.length; i++) {
      var state = timings[i];
      if (state.timeId1 == timingId) {
        tmp[i].isDone1 = true;
        tmp[i].present1 = presentCo;
        tmp[i].legalAbsent1 = legalAbsentCo;
        tmp[i].unLegalAbsent1 = unLegalAbsentCo;
      }
      else if (state.timeId2 == timingId) {
        tmp[i].isDone2 = true;
        tmp[i].present2 = presentCo;
        tmp[i].legalAbsent2 = legalAbsentCo;
        tmp[i].unLegalAbsent2 = unLegalAbsentCo;
      }
    }

    setTimings(tmp);
  }
  const showPresentAbsentForm = function (timeId, timeIndex) {
    setCurrentTimeId(timeId);
    setCurrentTimeIndex(timeIndex);
    setPresentAbsentFormVisible(true);
  }
  const showOperationForm = function (schoolClass, operation) {
    setOperation(operation);
    setSchoolClass(schoolClass);
    setOperationFormVisible(true);
  }
  const closePresentAbsentForm = function () {
    setPresentAbsentFormVisible(false);
  }
  const createSimpleButton = function (timeId, timeIndex) {
    return (
      <div onClick={() => showPresentAbsentForm(timeId, timeIndex)} style={{position:"relative", display:"inline-block", float:"right", width:"32px", padding:"5px 0px 0px 0px", marginRight:"6px", border:"1px solid #b0b0b0", borderRadius:"5px", backgroundColor: "rgb(200, 246, 253)", color: "rgb(47, 83, 194)", cursor: "pointer"}}>
        <i class="bi bi-ui-checks-grid"></i>
      </div>
    );
  }
  const createTimeDelayButton = function (schoolClass) {
    return (
      <div onClick={() => showOperationForm(schoolClass, "student_delay")} style={{position:"relative", display:"inline-block", float:"right", width:"32px", padding:"5px 0px 0px 0px", marginRight:"6px", border:"1px solid #b0b0b0", borderRadius:"5px", backgroundColor: "rgb(241, 200, 253)", color: "rgb(114, 47, 194)", cursor: "pointer"}}>
        <i class="bi bi-clock-history"></i>
      </div>
    );
  }
  const createSimpleDeleteButton = function (timeId) {
    return (
      <div onClick={() => btnDeleteByIdClicked(timeId)} style={{position:"relative", display:"inline-block", float:"right", width:"32px", padding:"5px 0px 0px 0px", marginRight:"6px", border:"1px solid #b0b0b0", borderRadius:"5px", backgroundColor: "rgb(253, 200, 200)", color: "rgb(194, 47, 47)", cursor: "pointer"}}>
        <i class="bi bi-trash"></i>
      </div>
    );
  }
  return (
    <div>
      <ShowVideo videoId="present_absent" top={65} md={6} />
      {
        loading ?
          <>loading...</>
          :
          <>
            <table>
              <tbody>
                <tr>
                  <td style={{ width: "70px" }}>امروز : </td>
                  <td style={{ width: "140px" }}>{util.SeperateDate(date)}</td>
                  <td style={{ width: "80px" }}>{weekDayName}</td>

                  <td></td>
                </tr>
              </tbody>
            </table>
            <table border="1" style={{ borderCollapse: 'collapse', width: '100%', maxWidth: "400px" }}>
              <tbody>
                {
                  dayParts.map((zang) => {
                    return (
                      <tr>
                        <td style={{ textAlign: "center", width: "70px", padding: "5PX" }}>{zang.title}</td>
                        <td style={{ textAlign: "center", padding: "5PX" }}>
                          {
                            timings.map((state) => {
                              return (
                                state.timeIndex == zang.index ?
                                  <>
                                    {
                                      state.timeId1 == "" ? <></>
                                        :
                                        <div style={{ minWidth: "170px", backgroundColor: ((state.isDone1) ? "#daf7e3ff" : "#f7dbc5ff"), height: "83px", position: "relative", margin: "3px", width: "calc(100% - 3px)", padding: "3px", borderRadius: "5px", border: "1px solid #b0b0b0" }}>


                                          <div title={state.schoolClass1.name + " - " + state.course1.name} style={{ position: "absolute", right: "5px", top: "2px", width: "calc(100% - 10px)", height: "22px", overflow: "hidden", textAlign: "right", fontSize: "8pt" }}>
                                            {state.schoolClass1.name} - {state.course1.name}
                                          </div>
                                          <table style={{ borderCollapse: "collapse", position: "absolute", right: "5px", top: "20px", width: "calc(100% - 30px)" }}>
                                            <tbody>
                                              <tr>
                                                <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "left", paddingLeft:"3px" }}>حاضر</td>
                                                <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "right", paddingRight:"3px" }}>{state.present1}</td>
                                                <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "left", paddingLeft:"3px" }}>غایب</td>
                                                <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "right", paddingRight:"3px"}}>{(state.legalAbsent1 + state.unLegalAbsent1)}</td>
                                              </tr>
                                              <tr>
                                                <td colSpan={4} style={{padding:"5px 0px"}}>
                                                  {createSimpleButton(state.timeId1, state.timeIndex)}
                                                  {createTimeDelayButton(state.schoolClass1)}
                                                  {createSimpleDeleteButton(state.timeId1)}
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                    }
                                    {
                                      state.timeId2 == "" ? <></>
                                        :
                                        <div style={{ minWidth: "190px", backgroundColor: ((state.isDone2) ? "#daf7e3ff" : "#f7dbc5ff"), height: "68px", position: "relative", margin: "3px", width: "calc(100% - 3px)", padding: "3px", borderRadius: "5px", border: "1px solid #b0b0b0" }}>
                                          <div title={state.schoolClass2.name + " - " + state.course2.name} style={{ position: "absolute", right: "5px", top: "2px", width: "calc(100% - 10px)", height: "22px", overflow: "hidden", textAlign: "right", fontSize: "8pt" }}>
                                            {state.schoolClass2.name} - {state.course2.name}
                                          </div>
                                          <table style={{ borderCollapse: "collapse", position: "absolute", right: "5px", top: "20px", width: "calc(100% - 30px)" }}>
                                            <tbody>
                                              <tr>
                                                <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "left", paddingLeft:"3px" }}>حاضر</td>
                                                <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "right", paddingRight:"3px" }}>{state.present2}</td>
                                                <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "left", paddingLeft:"3px" }}>غایب</td>
                                                <td style={{ fontSize: "8pt", border: "1px solid #b0b0b0", textAlign: "right", paddingRight:"3px"}}>{(state.legalAbsent2 + state.unLegalAbsent2)}</td>
                                              </tr>
                                              <tr>
                                                <td colSpan={4} style={{padding:"5px 0px"}}>
                                                  {createSimpleButton(state.timeId2, state.timeIndex)}
                                                  {createTimeDelayButton(state.schoolClass2)}
                                                  {createSimpleDeleteButton(state.timeId2)}
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                    }
                                  </>
                                  : <></>
                              )
                            })
                          }
                        </td>
                      </tr>
                    )
                  })
                }
                <tr>
                  <td>
                    hhhhhh
                  </td>
                </tr>
              </tbody>
            </table>
            <table border="1" style={{ borderCollapse: 'collapse', width: '100%', maxWidth: "400px" }}>
              <tbody>
                <tr>
                  <td colSpan={2} style={{textAlign:"center", padding:"5px"}}>راهنمای دکمه ها</td>
                </tr>
                <tr>
                  <td style={{width:"42px"}}>
                    <div style={{width:"32px", textAlign:"center", padding:"5px 0px 0px 0px", marginRight:"1px", border:"1px solid #b0b0b0", borderRadius:"5px", backgroundColor: "rgb(200, 246, 253)", color: "rgb(47, 83, 194)", cursor: "pointer"}}>
                      <i class="bi bi-ui-checks-grid"></i>
                    </div>
                  </td>
                  <td style={{textAlign:"right"}}>ثبت حضورو غیاب</td>
                </tr>
                <tr>
                  <td style={{width:"42px"}}>
                    <div style={{width:"32px", textAlign:"center", padding:"5px 0px 0px 0px", marginRight:"1px", border:"1px solid #b0b0b0", borderRadius:"5px", backgroundColor: "rgb(241, 200, 253)", color: "rgb(114, 47, 194)", cursor: "pointer"}}>
                      <i class="bi bi-clock-history"></i>
                    </div>
                  </td>
                  <td style={{textAlign:"right"}}>ثبت تاخیر ورود</td>
                </tr>
                <tr>
                  <td style={{width:"42px"}}>
                    <div style={{width:"32px", textAlign:"center", padding:"5px 0px 0px 0px", marginRight:"1px", border:"1px solid #b0b0b0", borderRadius:"5px", backgroundColor: "rgb(253, 200, 200)", color: "rgb(194, 47, 47)", cursor: "pointer"}}>
                      <i class="bi bi-trash"></i>
                    </div>
                  </td>
                  <td style={{textAlign:"right"}}>حذف حضورو غیاب</td>
                </tr>
              </tbody>
            </table>
          </>
      }
      {
        presentAbsentFormVisible ?
          <PresentAbsentSave hideLegalAbsent={true} timingId={currentTimeId} runClassDate={date} timeIndex={currentTimeIndex} weekDayName={weekDayName} onChange={(timingId, presentCo, legalAbsentCo, unLegalAbsentCo) => { onPresentAbsentChanged(timingId, presentCo, legalAbsentCo, unLegalAbsentCo) }} onClose={() => closePresentAbsentForm()} />
          :
          <></>
      }
      {
        operationFormVisible ?
          <SchoolClassOperation schoolClass={schoolClass} operation={operation} onClose={() => setOperationFormVisible(false)} />
          :
          <></>
      }

      <ShowError visible={errorVisible} message={errorMessage} closeError={() => { setErorVisible(false) }} />
      <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
    </div>
  );
}
